module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p14s1title":[{"p14s1titleF":true,"p14s1titleT":"Accident, Liability and Displacement insurances"}]},"es":{"p14s1title":[{"p14s1titleF":true,"p14s1titleT":"Contrata un seguro de Accidentes, Responsabilidad Civil y Desplazamiento"}]}}')
  delete Component.options._Ctor
}
